import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSortUp1 = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 748,
	height: 423,
	viewBox: "0 0 748 423",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M726.297 323.833C753.638 351.221 768.65 422.797 679.191 422.797L67.991 422.797C-18.5502 422.797 -6.45605 351.221 20.9322 323.833L324.085 20.5855C351.426 -6.70864 395.709 -6.70865 423.097 20.5855L726.297 323.833Z",
		fill: "#000"
	})
});
export default SvgSortUp1;
